import { TEMP } from "@zapier/canvas-constants";
import { Node, NodeProps } from "@xyflow/react";
import {
  NodeType,
  EphemeralNodeType,
  PersistedNodeType,
} from "@zapier/canvas-state";

import { DefaultNode } from "./DefaultNode";
import { PathNode } from "./PathNode";
import { ZapNode } from "./ZapNode";
import { TextNode } from "./TextNode";
import { ZapStepNode } from "./ZapStepNode";
import { TempNode } from "./TempNode";
import { GroupNode } from "./GroupNode";
import { SuggestedNode } from "./SuggestedNode/SuggestedNode";

type CanvasNodeTypes = {
  [key in NodeType]: React.ComponentType<NodeProps<Node<any>>>;
};

type EphemeralNodeTypes = {
  [key in EphemeralNodeType]: React.ComponentType<NodeProps<Node<any>>>;
};

type PersistedNodeTypes = {
  [key in PersistedNodeType]: React.ComponentType<NodeProps<Node<any>>>;
};

// Ephemeral node types not persisted to the BE
const ephemeralNodes: EphemeralNodeTypes = {
  zapStep: ZapStepNode,
  suggested: SuggestedNode,
  [TEMP]: TempNode,
};

const persistedNodes: PersistedNodeTypes = {
  default: DefaultNode,
  group: GroupNode,
  zap: ZapNode,
  path: PathNode,
  text: TextNode,
};

export const nodeTypes: CanvasNodeTypes = {
  ...persistedNodes,
  ...ephemeralNodes,
};
